import Button from "@Atom/Button";
import DoodleGradientCard from "@Atom/DoodleGradientCard";
import Icon from "@Atom/Icon";
import { decryptStorageData } from "@Helpers/encryptDecrypt";
import { useEffect, useMemo, useState } from "react";
import Styles from "./style.module.scss";
import Searchbar from "@Atom/Searchbar";
import Table from "@Molecule/Table";
import Avatar from "@Atom/Avatar";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "@Molecule/Footer";
import useWindowSize from "@Hooks/useWindowSize";
import useQuery from "@Hooks/useQuery";
import { useDebounce } from "@Hooks/useDebounce";

export default function AdminClassLayout({ dataActive, dataInactive }) {
  const user = decryptStorageData("user", localStorage);
  const navigate = useNavigate();
  const [classType, setClassType] = useState(0);
  const [tableTab, setTableTab] = useState(0);
  const query = useQuery();
  const limitQuery = query.get("l") || 10;
  const searchQuery = query.get("s") || "";
  const pageQuery = query.get("p") || 1;
  const [searchTerm, setSearchTerm] = useState(searchQuery);
  const [page, setPage] = useState(pageQuery);
  const [limit, setLimit] = useState(limitQuery);
  const { pathname } = useLocation();
  const debouncedTrigger = useDebounce(searchTerm, 200);

  const { width } = useWindowSize();

  useEffect(() => {
    navigate(
      `${pathname}?c=1&l=${limit}&p=${page}&s=${searchTerm}&t=${
        classType ? "PRAKERJA" : "GENERAL"
      }`,
      { replace: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, navigate, pathname, debouncedTrigger, classType]);

  useEffect(() => {
    setPage(1);
  }, [tableTab, classType, searchTerm]);

  const dataToShow = useMemo(() => {
    if (!tableTab) {
      return dataActive;
    } else {
      return dataInactive;
    }
  }, [tableTab, dataActive, dataInactive]);

  const template = useMemo(() => {
    return {
      data: dataToShow.data,
      columns: [
        {
          name: "title",
          width: width > 768 ? "455px" : "200px",
          title: "Judul Kelas",
          renderData: (row) => (
            <span
              onClick={() => navigate(`${row._id}`)}
              style={{ cursor: "pointer" }}
            >
              {row.title}
            </span>
          ),
        },
        {
          name: "",
          title: "Instruktur",
          renderData: (row) => (
            <div className={Styles.instructor}>
              <Avatar
                imgUrl={row?.instructor?.profilePicture}
                iconName="user"
                iconSize="12px"
                size="24px"
              />
              <span>{row?.instructor?.name}</span>
            </div>
          ),
          hideOnMobile: true,
        },
        {
          name: "type",
          title: "Tipe Kelas",
          hideOnMobile: true,
        },
        {
          name: "",
          title: "Tgl. Pembuatan",
          renderData: (row) => (
            <span>{moment(new Date(row?.createdAt)).format("ll")}</span>
          ),
          hideOnMobile: true,
        },
        {
          name: "",
          title: "",
          renderData: (row) => <span>Publish</span>,
          hideOnMobile: true,
        },
      ],
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width, dataToShow]);

  return (
    <div className={Styles.container}>
      <div className={Styles.wrapper}>
        <DoodleGradientCard className={Styles.header}>
          <div className={Styles.title}>
            <h3>Selamat datang {<span>{user?.name}</span>}</h3>
            <span>
              Berikut adalah daftar seluruh kursus/kelas yang kamu punya.
            </span>
          </div>
          <button onClick={() => navigate("new")}>
            <Icon icon={"plus"} size={10} />
            <span>Tambah Kelas</span>
          </button>
        </DoodleGradientCard>
        <div className={Styles.tabs}>
          <Button
            text={"Kelas Reguler"}
            variant="tab"
            isActive={classType === 0}
            onClick={() => setClassType(0)}
          />
          <Button
            text={"Kelas Prakerja"}
            variant="tab"
            isActive={classType === 1}
            onClick={() => setClassType(1)}
          />
        </div>
        <div className={Styles.content}>
          <div className={Styles.contentTabs}>
            <Button
              variant="table-tab"
              text={"Kelas Aktif"}
              dataLength={dataActive.totalData}
              isActive={tableTab === 0}
              onClick={() => setTableTab(0)}
            />
            <Button
              variant="table-tab"
              text={"Kelas Selesai"}
              dataLength={dataInactive.totalData}
              isActive={tableTab === 1}
              onClick={() => setTableTab(1)}
            />
          </div>
          <div className={Styles.contentFilter}>
            <Searchbar
              value={searchTerm}
              setValue={setSearchTerm}
              placeholder="Cari kelas/instruktur"
            />
            <Button
              text={"Filter"}
              startIcon={"setting-4"}
              variant="neutral-outlined-2"
            />
          </div>

          <Table
            data={template?.data}
            totalData={template?.data?.length}
            totalPage={Math.ceil(dataToShow.totalData / limit)}
            columns={template?.columns}
            page={page}
            setPage={setPage}
            className={`${Styles.table} ${
              !template?.data?.length ? Styles.grow : ""
            }`}
            limit={limit}
            setLimit={setLimit}
            withPagination
            expandComponent={(row) => (
              <div className={Styles.expandedInfo}>
                <div className={Styles.infoRow}>
                  <span>Instruktur</span>
                  <div className={Styles.instructor}>
                    <Avatar
                      imgUrl={row?.instructor?.profilePicture}
                      iconName="user"
                      iconSize="12px"
                      size="24px"
                    />
                    <span>{row?.instructor?.name}</span>
                  </div>
                </div>
                <div className={Styles.infoRow}>
                  <span>Tipe Kelas nya</span>
                  <span>{row?.type}</span>
                </div>
                <div className={Styles.infoRow}>
                  <span>Tgl. Pembuatan</span>
                  <span>{moment(new Date(row?.createdAt)).format("ll")}</span>
                </div>
              </div>
            )}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
}
